import { propertyAmenitiesQueryKeys as e } from "./usePropertyAmenitiesQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { propertyAmenitiesApi as n } from "@maat/api-main";
//#region src/propertyAmenities/usePropertyAmenities.ts
var r = (r, i, a, o) => t({
	queryKey: e.list({
		category: r,
		popular: i,
		search: a,
		scope: o
	}),
	queryFn: () => n.getPropertyAmenities(r, i, a, o)
});
//#endregion
export { r as usePropertyAmenities };
